(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drapeur-collection-header"]) return;
  try {
    
  if (!customElements.get('drapeur-brand-story')) {
    customElements.define('drapeur-brand-story', class extends HTMLElement {
      connectedCallback() {
        this.copy = this.querySelector('[data-brand-copy]');
        this.button = this.querySelector('button');
        this.setAttribute('data-ready', '');
        this.toggleStory = () => {
          const expanded = this.toggleAttribute('data-expanded');
          this.button.setAttribute('aria-expanded', String(expanded));
          this.button.textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        };
        this.button.addEventListener('click', this.toggleStory);
        this.observer = new ResizeObserver(() => {
          if (!this.offsetWidth) return;
          const limit = parseFloat(getComputedStyle(this.copy).lineHeight) * 6;
          const walker = document.createTreeWalker(this.copy, NodeFilter.SHOW_TEXT);
          let bottom = 0;
          let node;
          while ((node = walker.nextNode())) {
            if (!node.textContent.trim()) continue;
            const range = document.createRange();
            range.selectNodeContents(node);
            for (const rect of range.getClientRects()) bottom = Math.max(bottom, rect.bottom);
          }
          const textHeight = bottom - this.copy.getBoundingClientRect().top;
          this.button.hidden = textHeight <= limit + 1;
        });
        this.observer.observe(this.copy);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.toggleStory);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drapeur-collection-seo-header"]) return;
  try {
    
  // Avoid native hash navigation triggering the collection's popstate/grid restore.
  document.addEventListener('click', function (event) {
    const link = event.target.closest?.('.drp-seo-header__link');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById('DrapeurCollectionSeoDescription');
    if (!target) return;
    event.preventDefault();
    const url = new URL(window.location.href);
    url.hash = target.id;
    window.history.replaceState(window.history.state, '', url);
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
